<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="100px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item :label="$t('taskList.bizNo')" prop="bizNo">
                    <el-input class="handle-input" v-model.trim="queryCondition['bizNo']" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('taskList.taskFlow')" prop="taskTypes">
                    <ic-select multiple style="width:100%" :clearable="true" v-model="queryCondition.taskTypes" :options="{
								STORE_FEEDBACK:'质量反馈',
								PROBLEM_REPORT_HANDLE:'问题报告处理'
								}"></ic-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="创建日期(从)" prop="dateFrom">
                    <el-date-picker style="width: 100%" v-model="queryCondition.dateFrom" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="创建日期(至)" prop="dateTo">
                    <el-date-picker style="width: 100%" value-format="yyyy-MM-dd" v-model="queryCondition.dateTo" type="date" :placeholder="$t('common.selDate')"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item :label="$t('taskList.eightBitCodeName')" prop="eightBitCodeName">
                      <el-input class="handle-input" v-model="queryCondition.eightBitCodeName" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row justify="center" type="flex" align="middle">
            <el-button size="mini" class="btn" type="primary" @click="queryData(1)">{{$t("common.search")}}</el-button>
            <el-button size="mini" type="primary" @click="resetForm()">{{$t("common.reset")}}</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-table :data="tableData" border max-height='540' highlight-current-row>
        <el-table-column show-overflow-tooltip sortable prop="taskName" :label="$t('apply.applyType')" min-width="130"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="bizNo" :label="$t('taskList.bizNo')" min-width="160"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="plantName" :label="$t('base.plant.plantName')" min-width="140"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="problemLevel" :label="$t('storeFeedback.problemLevel')" min-width="100" align="center"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="isRepeat" :label="$t('storeFeedback.isRepeat')" min-width="100" align="center">
          <template slot-scope="scope">{{scope.row.isRepeat|ic("COMMON",'YES_NO')}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="materialName" :label="$t('taskList.eightBitCodeName')" min-width="140"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="taskTypeName" :label="$t('taskList.taskFlow')" min-width="130"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="createDate" :label="$t('common.TaskCreationTime')" min-width="140"><template slot-scope="scope">{{scope.row.createDate|dateFormatFilter("YYYY-MM-DD HH:mm:ss")}}</template></el-table-column>
        <el-table-column show-overflow-tooltip sortable :label="$t('common.operation')" min-width="160">
          <template slot-scope="scope">
            <el-button size="mini" @click="audit(scope.row.taskType,scope.row.bizId,scope.row)" type="primary">{{$t("taskList.audit")}}</el-button>
            <el-button size="mini" @click="transfer(scope.row)" type="primary" v-if="scope.row.taskType==='PROBLEM_REPORT_HANDLE'&&scope.row.taskName==='MCD处理'&&scope.row.transferAuditor!=userId">转移</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination :page-sizes="[10,15,50,100]" @size-change="pageSizeChange" :page-size="queryCondition.pageSize" :current-page="queryCondition.page" @current-change="pageNumberChange" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </div>
    <el-dialog title="审核" :visible="auditDialog" @close="closeAuditDialog" width="1200px" class="dialog">
      <router-view></router-view>
    </el-dialog>
    <el-dialog title="选择人员" :visible="userDialog" @close="closeUserDialog" width="70%" class="dialog">
      <userDialog ref="userDialog" :paramInfo='paramInfo' @closeUserDialog="closeUserDialog"></userDialog>
    </el-dialog>
  </div>
</template>
<script>
import taskApi from "../../../api/myTask";
import { Message } from "element-ui";
import dataTableUtils from '../../../utils/dataTableUtils';
import IcSelect from "@/components/common/icSelect";
import pickupUser from "@/components/common/pickupUser";
import DateRanger from "@/components/common/dateRanger";
import userDialog from "./transferUser";
import commonFun from "@/utils/commonFun";
export default {
  name: 'user-manage',
  components: {
    DateRanger,
    IcSelect,
    userDialog
  },
  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      tableData: [],
      total: 0,
      labelPosition: 'right',
      queryCondition: {
        page: 1,
        pageSize: 15,
        bizNo: '',
        taskTypes: [],
        dateFrom: '',
        dateTo: '',
        taskName: '',
        taskTypeName: '',
        eightBitCodeName: '',
      },
      auditDialog: false,
      userDialog: false,
      userForm: {
        id: '',
        name: '',
        login: '',
        routeNodes: [],
        authorities: []
      },
      routeNodes: [],
      userRouteNodes: [],
      authorities: [],
      userAuthorities: [],
      authSearch: '',
      routeObj: {
        key: 'routeNodeId',
        label: 'routeNodeName'
      },
      src: '',
      paramInfo: null,
      userId: "",
    }
  },
  created() {
    this.queryData(1);
  },
  mounted() {
    this.userId = localStorage.getItem('ms_userId')
    console.log("🚀 ~ file: myTask-SFB.vue:146 ~ mounted ~ this.userId:", this.userId)
    if (this.$route.meta.auditDialog) {
      this.auditDialog = true;
    } else {
      this.auditDialog = false;
    }
  },
  extends: dataTableUtils,
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      taskApi.myStoreFeedbackTasklist(this.queryCondition).then((res) => {
        this.tableData = res.data.records;
        this.tableData.forEach(row => {
          if (row.taskType == "PROBLEM_REPORT_HANDLE" || row.taskType == "STORE_FEEDBACK") {
            let bizInfo = row.bizNo.split(";");
            row.bizNo = bizInfo[0];
          }
        })
        this.total = res.data.total;
      });
    },
    /**
     * 多选
     * @param val
     */
    authChange(val) {
      this.userForm.authorities = val;
    },
    resetForm() {
      this.$refs['queryCondition'].resetFields();
      this.queryCondition = {
        page: 1,
        pageSize: 15,
        bizNo: '',
        taskTypes: [],
        dateFrom: '',
        dateTo: '',
        taskName: '',
        taskTypeName: '',
        eightBitCodeName: '',
      }
      this.queryData();
    },
    transfer(row) {
      var paramInfo = {
        bizId: row.bizId,
        taskId: row.taskId
      }
      this.paramInfo = JSON.stringify(paramInfo)
      console.log("🚀 ~ file: myTask-SFB.vue:197 ~ transfer ~ this.paramInfo:", this.paramInfo)
      this.userDialog = true
      this.$refs.userDialog.selectDataAll = ""
    },
    audit(taskType, bizId, row) {
      var that = this;
      let taskName = row.taskName
      console.log(taskName)
      switch (taskType) {
        case "QUOTATION":
          if (row.bizNo.startsWith('PX')) {
            that.$router.push({ path: `/inquiry-quotation-product-sp-detail`, query: { roundId: bizId } });
          } else {
            that.$router.push({ path: `/quotation-sp-detail/${bizId}` });
          }
          break;
        case "MSV":
          if (taskName == "审核中") {
            that.$router.push({ path: `/visitReportAudit`, query: { ttMsvReportId: bizId } });
          } else {
            that.$router.push({ path: `/visitReport-add`, query: { ttMsvReportId: bizId } });
          }
          break;
        case "SENSORY_REPORT":
          this.$router.push({
            path: `/sensoryTemplate-add`,
            query: { ttSensoryTemplateId: bizId, taskApproval: true },
          });
          break;
        case "LINE_SOURCING":
        case "PRODUCT_SOURCING":
          this.$router.push({ name: "auditSourcing", params: { sourcingId: bizId } });
          that.auditDialog = true;
          break;
        case "PROBLEM_REPORT_HANDLE":
          switch (taskName) {
            case '调查报告待提交':
              that.$router.push({ name: `feedbackReportView`, query: { feedbackReportId: bizId } });
              break;
            case '问题报告驳回':
              that.$router.push({ name: "feedbackReportView", query: { action: 'audit', feedbackReportId: bizId } });
              break;
            case 'MCD处理':
              that.$router.push({ path: `/feedbackReport/approve`, query: { feedbackReportId: bizId } });
              break;
            case '质量反馈中心处理':
              that.$router.push({ path: `/feedbackReport/approve`, query: { feedbackReportId: bizId } });
              break;
            case '质量反馈中心处理疑问反馈':
              that.$router.push({ path: `/feedbackReportQuestion-detail`, query: { feedbackReportId: bizId } });
              break;
            default:
              that.$router.push({ name: "feedbackReportView", query: { action: 'audit', feedbackReportId: bizId } });
          }
          break;
        case "STORE_FEEDBACK":
          this.$router.push({
            path: `/storeFeedback-detail`,
            query: {
              feedbackId: bizId
            }
          });
          break;
      }
    },
    closeAuditDialog() {
      this.auditDialog = false;
      this.queryData()
      this.$router.go(-1);
    },
    closeUserDialog() {
      this.userDialog = false
      this.paramInfo = null
      this.queryData()
    }
  }
}
</script>
<style scoped>
.handle-input {
  width: 95%;
}
.dialog-input {
  width: 85%;
}
.dialog >>> .el-dialog__body {
  max-height: 450px;
  overflow: auto;
}
.el-select {
  width: 100%;
}
</style>
<style scoped>
/* .myTask .el-date-editor--daterange.el-input__inner {
  width: auto;
} */
</style>

